export const getTrainingProgramsAPI = "/training-programs";
export const getTrainingProgramApplicationsAPI = "/training-program-applications";
export function getTrainingProgramApplicationAPI(id){ return "/training-program-applications/"+id;} 
export const getExportTrainingProgramApplicationsAPI = "/training-program-applications/export";
export const getExportKeysAPI="/training-program-applications/export-keys";
export const updateExportKeysAPI="/training-program-applications/export-keys";
